import { useNavigate, useParams } from "react-router-dom";
import BasicPage from "../../components/BasicPage/BasicPage";
import styles from "./NewsPost.module.css";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { PostContext } from "../../components/PostProvider/PostProvider";
import ArrowSVG from "../../components/SVGs/ArrowSVG";
import useDetectKeelMind from "../../hooks/useDetectKeelMind";
import CategoryChip from "../../components/CategoryChip/CategoryChip";
import usePageTitle from "../../hooks/usePageTitle";

function NewsPost() {
    // const navigate = useNavigate();
    const isKeelMind = useDetectKeelMind(true);
    const { id } = useParams();
    const { cache, getSpecificPost } = useContext(PostContext);
    const post = useMemo(() => cache.posts[id] ?? {}, [cache.posts, id]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    usePageTitle(post?.title?.rendered + " | News");

    function getFormattedDateFromPost(post) {
        const date = new Date(post.date);
        const options = {
            month: "long",
            day: "numeric",
            year: "numeric",
        };
        return `${date.toLocaleDateString("en-US", options)}`;
    }

    function handleBackButton() {
        navigate(isKeelMind ? "/news" : "/mind/news");
    }

    const handleFetchError = useCallback(() => {
        navigate(isKeelMind ? "/news" : "/mind/news");
    }, [isKeelMind, navigate]);

    useEffect(() => {
        getSpecificPost(id, setLoading, isKeelMind, handleFetchError);
    }, [getSpecificPost, id, isKeelMind, handleFetchError]);

    return (
        <BasicPage>
            <div id={styles.container}>
                <button id={styles.back_button} onClick={handleBackButton}>
                    <ArrowSVG style={{ rotate: "180deg" }} />
                    Back to News Room
                </button>
                {loading ? (
                    <div id={styles.hero} className="shimmer"></div>
                ) : (
                    post?.featured_image_url && (
                        <div id={styles.hero}>
                            <img
                                src={post?.featured_image_url}
                                alt=""
                                id={styles.featured_image}
                            />
                            <div id={styles.gradient_cover}></div>
                        </div>
                    )
                )}
                <div
                    id={styles.post_sheet}
                    className={post?.featured_image_url ? styles.offset : ""}
                >
                    <div id={styles.heading}>
                        <div id={styles.categories_container}>
                            {post?.categories?.map(({ name, slug }) => (
                                <CategoryChip
                                    key={name}
                                    name={name}
                                    slug={slug}
                                />
                            ))}
                        </div>
                        <h1 id={styles.title}>{post?.title?.rendered}</h1>
                        {!loading && (
                            <div id={styles.date}>
                                <strong>Posted</strong>{" "}
                                {getFormattedDateFromPost(post)}
                            </div>
                        )}
                    </div>
                    <hr />
                    <div
                        id={styles.body}
                        dangerouslySetInnerHTML={{
                            __html: post?.content?.rendered,
                        }}
                    ></div>
                </div>
            </div>
        </BasicPage>
    );
}

export default NewsPost;
